import axios from 'axios';
import urls from './Urls';
import { action, makeObservable, observable, runInAction } from "mobx";
import { jwtDecode } from 'jwt-decode';
import dictionary from './Dictionary';
import dictionaryLog from './DictionaryLog';
import customers from './Customers';
import groups from './Groups';
import Swal from 'sweetalert2';
import { startTokenCheck, stopTokenCheck } from '../Utils/user';

class User {
    name = null;
    role = null;
    token = null;
    email = null;
    tokenCheckInterval = null; // variable for checking token
    limitedAdmin = ["test_admin@gmail.co", "dvora99170@gmail.com"] // ToDo: זה פתרון זמני, צריך להוסיף את כל המנהלים המוגבלים כאן

    constructor() {
        makeObservable(this, {
            name: observable,
            role: observable,
            email: observable,
            limitedAdmin: observable,
            login: action,
            logout: action
        });
        this.name = localStorage.getItem("name");
        this.role = localStorage.getItem("role");
        this.token = localStorage.getItem("token");
        this.email = localStorage.getItem("email");

        if (!this.tokenCheckInterval)
            this.tokenCheckInterval = startTokenCheck(); // start checking token
    }

    async login(email, password) {
        let response;
        if (email && password) { // login with email and password
            response = await axios.post(urls.user.login, { email, password }, { withCredentials: true });
        }
        else { // login with OAuth 2.0 - using Google as an example
            response = await axios.get(urls.user.getOne, { withCredentials: true });
        }
        const token = response.data.token;
        let welcomeMessage;

        runInAction(() => {
            const jwtPayload = jwtDecode(token);
            if (jwtPayload.role === 'admin') {
                this.role = jwtPayload.role;
                this.name = jwtPayload.firstName + ' ' + jwtPayload.lastName;
                this.token = token;
                this.email = jwtPayload.email;

                localStorage.setItem("name", this.name);
                localStorage.setItem("role", this.role);
                localStorage.setItem("token", this.token);
                localStorage.setItem("email", this.email);

                email && dictionary.getAll();
                welcomeMessage = `Welcome ${this.name}!`;

                if (!this.tokenCheckInterval)
                    this.tokenCheckInterval = startTokenCheck(); // start checking token
            } else {
                welcomeMessage = `הגישה למנהלים בלבד`;
                this.logout();
            }
        });
        return welcomeMessage;
    }

    async logout() {
        try {
            // Clear the token from the cookie
            const response = await axios.post(urls.user.logout, {}, { withCredentials: true });

            // Clear the session from the Ministry of Education of Education
            setTimeout(() => { // wait 5 seconds before redirecting, To be able to read the error message.
                if (this.name) return; // if the user is not logged in, don't redirect
                const redirectTo = process.env.NODE_ENV === "development" ?
                    `https://localhost:3000/` : `https://admin.lexillon.co.il/`;
                window.location.href = `${urls.user.logoutMinistryOfEducation}?redirectTo=${redirectTo}`;
            }, 5000);

            // Clear the Mobx data
            this.clear();

            // Show success message
            console.log(response.data);
            // Swal.fire({
            //     title: 'You have safely logged out!',
            //     text: 'All data has been deleted from the browser.',
            //     icon: 'success',
            //     confirmButtonText: 'OK',
            //     width: 'auto'
            // });

        } catch (error) {
            // Show error message
            console.log('error logout: ', error);
            Swal.fire({
                title: 'Warning!',
                text: 'There was an issue deleting the token from the cookie. Please urgently contact support.',
                icon: 'warning',
                confirmButtonText: 'OK',
                width: 'auto'
            });

        } finally {
            // Clear the Mobx data
            this.clear();
        }
    }

    clear() {
        this.name = null;
        this.role = null;
        this.token = null;
        this.email = null;
        localStorage.removeItem("name");
        localStorage.removeItem("role");
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        stopTokenCheck(this.tokenCheckInterval); // stop checking token
        this.tokenCheckInterval = null;

        dictionary.clear();
        dictionaryLog.clear();
        customers.clear();
        groups.clear();
    }

    _stopTokenCheck() {
        stopTokenCheck(this.tokenCheckInterval);
        this.tokenCheckInterval = null;
    }

    _startTokenCheck() {
        if (!this.tokenCheckInterval) {
            this.tokenCheckInterval = startTokenCheck();
        }
    }
}

const user = new User();
export default user;
